import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { SendPromotionEmailOrSmsMutationInput } from '@/models/marketing';

export const sendPromotionEmailOrSms = async ({
  communicationType,
  promoCode,
  phoneNumber,
  email,
}: SendPromotionEmailOrSmsMutationInput) => {
  const response = await mutationExecute({
    variables: {
      communicationType,
      promoCode,
      phoneNumber,
      email,
    },
    mutation: graphql(`
      mutation sendPromotionEmailOrSms($communicationType: String!, $promoCode: String!, $phoneNumber: String, $email: String) {
        sendPromotionEmailOrSms(communicationType: $communicationType, promoCode: $promoCode, phoneNumber: $phoneNumber, email: $email)
      }
    `),
  });

  return response.data?.sendPromotionEmailOrSms ?? false;
};
